import { useEffect, useRef, useState } from 'react';
import noop from '../../../utils/noop';
/** tracks if the image has had it's src file loaded and optionally
 *
 *  @example
 *  const { isLoading, onSrcLoadFinish } = useImgIsLoading(
 *    previewFile.src,
 *    () => console.log('finally loaded')
 *  );
 *
 *  // ...
 *  <img
 *    ...
 *    src={previewFile.src}
 *    className={classnames(isLoading && styles['loading'])}
 *    onLoad={onSrcLoadFinish}
 *    onError={onSrcLoadFinish}
 *    ... />
 */ export function useImgIsLoading(/** img element to monitor for loading */ imgRef, /** src used in img */ src, /** fired when the image src is loaded (over the wire or from the cache) */ onLoaded = noop) {
    var _imgRef_current;
    const [isLoading, setIsLoading] = useState(true);
    const previousSrc = useRef(undefined);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(()=>{
        if (previousSrc.current !== src && !isLoading) {
            setIsLoading(true);
        }
        previousSrc.current = src;
    });
    return {
        // safari handles cached images a bit different than ff or chrome so
        // we need to check the complete property or this update sizes on previously viewed
        isLoading: isLoading && !((_imgRef_current = imgRef.current) === null || _imgRef_current === void 0 ? void 0 : _imgRef_current.complete) || previousSrc.current !== src,
        onSrcLoadFinish: ()=>{
            onLoaded();
            setIsLoading(false);
        }
    };
}
export default useImgIsLoading;

//# sourceMappingURL=useImageIsLoading.js.map